import config from 'constants/config'
import noop from 'lib/function/noop'
import { isLoggedIn } from 'selectors/accountSelectors'

// Disable global handlers so we don't accidently
// start spamming errors from 3rd party addons
const disabledIntegrations = new Set([
  'GlobalHandlers',
  'TryCatch',
])

let sentry
export function reportError(error, extras?: any, state?: App.State, tags?: Record<string, string>) {
  if (config.SENTRY_ID) {
    let loadPromise = Promise.resolve(sentry)
    if (!sentry) {
      loadPromise = import(/* webpackChunkName: "Sentry" */ '@sentry/browser').then(sentry => {
        sentry.init({
          dsn: config.SENTRY_ID,
          environment: config.SENTRY_ENV || 'development',
          release: config.commitSha,
          integrations: intergrations => intergrations.filter(i => !disabledIntegrations.has(i.name)),
        })
        return sentry
      })
    }

    return loadPromise.then((sentry) => new Promise(resolve => sentry.withScope((scope) => {
      scope.setExtras(extras)
      try {
        tags && scope.setTags(tags)
      } catch {
        // nothing
      }

      try {
        if (state) {
          scope.setExtras({
            headlessMode: state.config.headlessMode,
            regionCode: state.geo.currentRegionCode,
            query: state.router.location.search,
            path: state.router.location.pathname,
            recentHistory: state.routeHistory.recentHistory,
            loggedIn: isLoggedIn(state),
            cartItems: JSON.stringify(state.checkout.cart.items, null, 2),
          })
        }
      } catch {
        // nothing
      }
      // Sentry doesn't like capturing a non "Error()" object
      // so if someone throws something that isn't an error, wrap it in an error
      const exception = error instanceof Error ? error : new Error(JSON.stringify(error))
      const id = sentry.captureException(exception)
      resolve(id)
    })))
    // discard any errors while trying to report the error.
    // Blowing up while trying to report an error isn't ideal!
      .catch(noop)
  } else {
    return Promise.resolve(undefined)
  }
}
